(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7914],{

/***/ 5601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1503);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6268);
/* harmony import */ var _components_utils_local_policy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5200);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2676);






var Returns = function Returns(props) {
  var _storeData$legalInfo;

  var storeData = props.storeData,
      themeData = props.themeData;
  var returns = (storeData === null || storeData === void 0 ? void 0 : (_storeData$legalInfo = storeData.legalInfo) === null || _storeData$legalInfo === void 0 ? void 0 : _storeData$legalInfo.returns) || _components_utils_local_policy__WEBPACK_IMPORTED_MODULE_2__/* .localLegalInfo.returns */ .y.returns || "";
  returns = returns.replace("{{dispatch time}}", storeData.dispatchTime);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("main", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
        className: "sidepage-title",
        children: "Shipping & Returns"
      }), returns.trim() !== "" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "sidepage-content",
        dangerouslySetInnerHTML: {
          __html: returns
        }
      }) : null]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      theme: themeData
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Returns);

/***/ }),

/***/ 9668:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/returns",
      function () {
        return __webpack_require__(5601);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9248,7234,6166,3352,9774,2888,179], function() { return __webpack_exec__(9668); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);